export const LABELS = {
    WITH_PROMO_CODE: 'with promo code',
    IF_ORDER_NOW: 'If Ordered Now!'
}
